import { render, staticRenderFns } from "./digit-e2.vue?vue&type=template&id=2a745070&"
import script from "./digit-e2.vue?vue&type=script&lang=js&"
export * from "./digit-e2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports